import type { FC } from 'react';
import { Container, Typography } from '@material-ui/core';

interface FooterPropTypes {
  justifyContent?: string;
}
export const Footer: FC<FooterPropTypes> = ({ justifyContent = 'center' }) => (
  <div>
    <Container
      maxWidth="lg"
      sx={{
        justifyContent,
        display: 'flex',
        py: 3
      }}
    >
      <Typography color="textSecondary" variant="caption">
        {'© '}
        {new Date().getFullYear()}
        {' BMCE EuroServices'}
      </Typography>
    </Container>
  </div>
);
